import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons';


import useAudio from 'hooks/useAudio';

import Answers from 'components/Answer';
import Button from 'components/Button';
import Explanation from 'components/Explanation';
import AskQuestion from 'components/AskQuestion';
import {
  QUESTION_ANSWERED,
  QUESTION_ASKED
} from 'config/types';

import { find } from 'lodash';

const Question = ({id, index, state, question, middle_question, explanation, answers, is_true, question_audio, explanation_audio, question_image, question_video, next, onSend, onAskQuestion}) => {
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  useEffect(() => setSelectedAnswers([]), [id])
  const updateAnswers = (id) => {
    if (find(selectedAnswers, saId => saId === id)) {
      setSelectedAnswers(selectedAnswers.filter(saId => saId !== id));
    } else {
      setSelectedAnswers([...selectedAnswers, id]);
    }
  }
  const [playingQuestion, toggleQuestion] = useAudio(question_audio);
  const [playingExplanation, toggleExplanation] = useAudio(explanation_audio);
  useEffect(() => {
    if(playingQuestion && explanation_audio)
      toggleQuestion();
  }, [playingQuestion, explanation_audio])

  const askQuestion = (data) => {
    onAskQuestion({...data, type: state === QUESTION_ASKED ? 'question' : 'explanation', question: id})
  }
  return (
    <div className="card mb-6">
      <div className='p-3 m-0 mb-3 has-background-primary-light'>
        <div className="level">
          <div className="level-left">
            <h3 className="title is-3 ">Question {index != -1 && `#${index + 1}`}</h3>
          </div>
          <div className="level-right">
            {(question_audio || explanation_audio) &&
            <Button onClick={() => {
              if(explanation_audio) {
                toggleExplanation()
              } else {
                toggleQuestion()
              }
            }}>
              <FontAwesomeIcon icon={playingQuestion || playingExplanation ? faVolumeMute : faVolumeUp} />
            </Button>
            }
          </div>
        </div>
      </div>
      {question_image && !question_video &&
      <div class="card-image">
        <div className="columns">
          <div className="column is-offset-one-quarter is-half">
            <figure className="image is-16by9">
              <img src={question_image} alt="Chargement en cours..." style={{objectFit: "contain"}} />
            </figure>
          </div>
        </div>
      </div>
      }
      {question_video &&
      <div class="card-image">
        <div className="columns">
          <div className="column is-offset-one-quarter is-half">
            <figure className="image is-16by9">
              <video muted mute loop controls autoPlay className="controlled-video" style={{objectFit: "contain"}}>
                <source src={question_video} />
              </video>
            </figure>
          </div>
        </div>
      </div>
      }
      <div className="card-content p-5">
        <div className="content">
        <h4 className="title is-4">{question}</h4>
        <Answers middleQuestion={middle_question} answers={answers} updateAnswers={updateAnswers} selectedAnswers={selectedAnswers} />
        {state === QUESTION_ASKED &&
        <Button className="is-fullwidth is-primary my-4" onClick={() => onSend({answers: selectedAnswers})}>
          Valider
        </Button>
        }
        {state === QUESTION_ANSWERED &&
          <Explanation explanation={explanation} isTrue={is_true} next={next} />
        }
        <AskQuestion onAskQuestion={askQuestion}/>
        </div>
      </div>
    </div>
  )
}

export default Question;